import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import SetNewOrg from './SetNewOrg';
import EditOrganizations from './EditOrganizations';

const styles = makeStyles(() => ({
  gridItemSections: {
    padding: '20px 0px 0px 0px',
  },
  gridContainers: {
    justifyContent: 'space-between',
    height: '100%',
  },
}));

const KSOrganizations = props => {
  const { ksOrgs } = props;

  const initialState = {
    id: null,
    orgName: '',
    orgTag: '',
  };
  const [createEditOrgDisable, setCreateEditOrgDisable] = useState(true);
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [orgState, setOrgState] = useState(initialState);
  const [killshotOrgs, setRows] = useState([]);
  const [includePrimeBrokerage, setIncludePrimeBrokerage] = useState(true);

  const classes = styles();

  const clearOrgState = () => {
    setOrgState(initialState);
    setIncludePrimeBrokerage(true);
    setIsEdit(false);
  };

  useEffect(() => {
    const newOrgs = ksOrgs.map(row => ({
      id: row.id,
      name: row.name,
      tag: row.inventory_tag,
      includeInPrime: row.include_in_prime,
    }));
    if (newOrgs.length > 0) {
      setIsLoading(false);
    } else {
      setIsLoading(true);
    }
    setRows(newOrgs);
  }, [ksOrgs]);

  return (
    <Grid container direction="row" className={classes.gridContainers}>
      <Grid item xs={6} className={classes.gridItemSections} style={{ maxHeight: '310px', paddingRight: '40px' }}>
        <EditOrganizations
          killshotOrgs={killshotOrgs}
          isLoading={isLoading}
          clearOrgState={clearOrgState}
          setCreateEditOrgDisable={setCreateEditOrgDisable}
          setIncludePrimeBrokerage={setIncludePrimeBrokerage}
          setIsEdit={setIsEdit}
          setOrgState={setOrgState}
        />
      </Grid>
      <Grid item xs={6} className={classes.gridItemSections} style={{ maxHeight: '310px', paddingLeft: '40px' }}>
        <SetNewOrg
          includePrimeBrokerage={includePrimeBrokerage}
          isEdit={isEdit}
          isDisable={createEditOrgDisable}
          killshotOrgs={killshotOrgs}
          orgState={orgState}
          clearOrgState={clearOrgState}
          setCreateEditOrgDisable={setCreateEditOrgDisable}
          setIncludePrimeBrokerage={setIncludePrimeBrokerage}
          setOrgState={setOrgState}
          setRows={setRows}
        />
      </Grid>
    </Grid>
  );
};

KSOrganizations.propTypes = {
  ksOrgs: PropTypes.array.isRequired,
};

export default KSOrganizations;
